export default "__VITE_ASSET__B698MebP__"